<template>
  <ListComponent title="Terms & Condition" :totalCount="totalItems">
    <template #list>
      <v-row class="ma-0">
        <v-col cols="4" class="px-0 pt-0 pb-2">
          <v-text-field
            label="Search"
            outlined
            dense
            append-icon="mdi-magnify"
            clearable
            hide-details="auto"
            v-model="filters.search"
            @input="searchTermsConditionList"
          ></v-text-field>
        </v-col>

        <v-col
          v-if="totalItems > 0"
          cols="8"
          class="px-0 pt-0 pb-2 d-flex justify-end"
        >
          <Pagination
            :pageNo="pageNo"
            :totalItems="totalItems"
            :pageSize="itemsPerPage"
            @itemsPerPageChange="itemsPerPageChanged"
            @prevPage="prevPage"
            @nextPage="nextPage"
          />
        </v-col>

        <v-col cols="12" class="pa-0">
          <AgGridVue
            style="width: 100%; height: calc(100vh - 172px)"
            class="ag-theme-alpine"
            id="myGrid"
            :columnDefs="headers"
            :context="context"
            @grid-ready="onGridReady"
            :defaultColDef="defaultColDef"
            :grid-options="gridOptions"
            :suppressDragLeaveHidesColumns="true"
            :rowData="allTermsConditionList"
          ></AgGridVue>
        </v-col>
      </v-row>
    </template>

    <template #dialogs>
      <TermsConditionForm
        v-model="showTermsConditionForm"
        :editMode="isEditing"
        :editTermsConditionID="editTermsConditionID"
        @refreshList="itemsPerPageChanged(20)"
      />
    </template>

    <template #actions>
      <v-btn
        v-if="permissions && permissions.add"
        color="primary"
        depressed
        @click="addTermsCondition"
      >
        <v-icon>mdi-plus</v-icon>
        <span>Add Terms & Condition</span>
      </v-btn>
    </template></ListComponent
  >
</template>

<script>
import ListComponent from "@/components/General/ListComponent.vue";
import { AgGridVue } from "ag-grid-vue";
import Pagination from "@/components/General/Pagination.vue";
import TermsConditionButton from "@/components/AgGridComponents/TermsConditionButton.vue";
import CustomHeader from "@/components/AgGridComponents/General/CustomHeader.vue";
import TermsConditionForm from "@/components/ModuleBased/dialogForms/TermsConditionForm.vue";

import {
  isAuthenticated,
  hasRouteAccess,
  getPermissions,
} from "@/utils/functions";

export default {
  components: {
    ListComponent,
    AgGridVue,
    Pagination,
    TermsConditionButton,
    TermsConditionForm,
    agColumnHeader: CustomHeader,
  },
  data() {
    return {
      sorting: {},
      showRemarksForm: false,
      deactivateChecklistId: null,
      deactivateChecklisRemark: {},
      checklistStatus: null,
      documentId: null,
      headers: [
        {
          headerName: "Name",
          field: "name",
          sortable: true,
        },
        {
          headerName: "Module Name",
          field: "module_name",
          sortable: true,
        },

        {
          headerName: "Is Default",
          field: "is_default",
          sortable: true,
        },

        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "TermsConditionButton",
          pinned: "right",
          width: 120,
        },
      ],
      allTermsConditionList: [],

      // pagination vars
      pageNo: 1,
      itemsPerPage: 20,
      totalItems: 0,
      filters: {},

      permissions: null,

      // ag-grid vars
      gridApi: null,
      gridColumnApi: null,
      defaultColDef: {
        resizable: true,
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridOptions.api.sizeColumnsToFit();
        },
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
        tooltipShowDelay: 0,
        rowHeight: 35,
      },

      //CheckList form
      showTermsConditionForm: false,
      isEditing: false,
      editTermsConditionID: null,
    };
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
    currentProfile() {
      if (JSON.parse(localStorage.getItem("userProfile"))) {
        return JSON.parse(localStorage.getItem("userProfile"));
      } else {
        return null;
      }
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
  },
  methods: {
    applyGridSort(key, type) {
      if (this.filters && !this.filters.ordering) {
        this.filters.ordering = [];
      }

      if (type == null) {
        delete this.sorting[key];
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(`-${key}`),
          1
        );
      } else if (type == "asc") {
        this.filters.ordering.push(key);
      } else if (type == "desc") {
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(key),
          1,
          `-${key}`
        );
      }
      if (this.filters.ordering.length == 0) {
        delete this.filters.ordering;
      }
      this.itemsPerPageChanged(20);
    },
    viewDocument(data) {
      window.open(data.document, "_blank");
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    searchTermsConditionList() {
      this.pageNo = 1;
      this.getTermsConditionList();
    },
    itemsPerPageChanged(e) {
      this.pageNo = 1;
      this.itemsPerPage = e;
      this.getTermsConditionList();
    },
    prevPage() {
      this.pageNo--;
      this.getTermsConditionList();
    },
    nextPage() {
      this.pageNo++;
      this.getTermsConditionList();
    },
    getTermsConditionList(params = {}) {
      this.$bus.$emit("showLoader", true);
      params = {
        offset: this.offset,
        limit: this.itemsPerPage,
        ...params,
        ...this.filters,
      };
      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }
      this.$api.termsCondition
        .getTermsConditionList(params)
        .then((res) => {
          this.allTermsConditionList = res.data;
          this.totalItems = res.count;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    addTermsCondition() {
      this.editTermsConditionID = null;
      this.isEditing = false;
      this.showTermsConditionForm = true;
    },
    editTermsCondition(id) {
      this.editTermsConditionID = id;
      this.isEditing = true;
      this.showTermsConditionForm = true;
    },
  },
  beforeMount() {
    if (!isAuthenticated()) {
      this.$router.push("/");
    } else if (!hasRouteAccess(this.$route)) {
      this.$router.push(`/${localStorage.getItem("user_type").toLowerCase()}`);
    } else {
      const permissions = getPermissions("configuration");
      if (!permissions || !permissions.view) {
        this.$bus.$emit("showToastMessage", {
          message: "You don't have access to this page",
          color: "error",
        });
        this.$router.push(
          `/app/${
            localStorage.getItem("user_type")
              ? localStorage.getItem("user_type").toLowerCase()
              : "error"
          }`
        );
      } else {
        this.permissions = { ...permissions };
        this.getTermsConditionList();
      }
    }
  },
};
</script>
